var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lqp2g6buxa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 0v2366H0V0h390z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qwe1lj4sab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.132 0a.2.2 0 0 1 .201.2v19.6a.2.2 0 0 1-.2.2h-.812a.2.2 0 0 1-.201-.2l-.001-18.551-5.1.001a.616.616 0 0 0-.607.625l.007.094.02.092 1.515 5c.068.224.25.387.468.428l.111.011h2.373c.335 0 .607.28.607.625a.62.62 0 0 1-.498.615l-.109.01H8.533c-.74 0-1.4-.46-1.68-1.153l-.057-.163L5.3 2.499 1.82 2.5a.616.616 0 0 0-.607.625l.007.09.018.087 1.435 5c.067.233.257.401.483.44l.1.008h3.376c.335 0 .607.28.607.625a.62.62 0 0 1-.498.615l-.109.01H3.255a1.822 1.822 0 0 1-1.69-1.177l-.055-.166-1.435-5A1.927 1.927 0 0 1 0 3.125c0-.975.722-1.776 1.645-1.866l.175-.009h3.482A1.832 1.832 0 0 1 6.843.009L7.02 0h6.113z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lqp2g6buxa)",
    transform: "translate(-32 -238)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qwe1lj4sab)",
    transform: "translate(35.333 238)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C21",
    d: "M0 0h13.333v20H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag2);
export default __webpack_public_path__ + "static/media/flag-2.ef0c612355274bed6a4009d3152de1ee.svg";
export { ForwardRef as ReactComponent };